import $ from "jquery";

$.validator.addMethod("requiredtrue", function (value, element, param) {
    return element.checked;
});

// Required true validation (checkbox)
$.validator.unobtrusive.adapters.addBool("requiredtrue");